function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  label {\n    ",
        "\n  }\n\n  div {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  & + & {\n    margin-top: 25px;\n  }\n\n  ",
        " {\n    min-height: 56px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import React from "react";
import propTypes from "prop-types";
import { FaRegTrashAlt } from "react-icons/fa";
import { Droppable, Draggable } from "react-beautiful-dnd";
import IconButton from "../IconButton";
import ItemRow from "./ItemRow";
import { Row, WrCol as Col } from "../../../grid";
import styled from "styled-components";
import * as phasesModule from "../../../../modules/phases";
import Card, { CardBody, CardHeader } from "../../../../components/card";
import { PhaseAllocationsActionsEnum } from "../stateReducer";
import { isServiceLevelDiscountingEnabled } from "../../../../modules/phases/utils";
var ValueColumn = styled(Col)(_templateObject(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.phases) === null || ref === void 0 ? void 0 : ref.itemGroup.valueColumn.container;
}, function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.phases) === null || ref === void 0 ? void 0 : ref.itemGroup.valueColumn.label;
}, function(param) {
    var theme = param.theme;
    var ref, ref1, ref2;
    return (ref = theme.components.phases) === null || ref === void 0 ? void 0 : (ref1 = ref.itemGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.valueColumn) === null || ref2 === void 0 ? void 0 : ref2.div;
});
var PhaseCard = styled(Card)(_templateObject1(), CardBody);
var defaultRenderHeader = function(options) {
    var renderName = options.renderName, dispatch = options.dispatch, totalHours = options.totalHours, totalRateCents = options.totalRateCents, groupIndex = options.groupIndex, formatCurrency = options.formatCurrency, disabled = options.disabled, effortUnit = options.effortUnit;
    var displayDiscounts = isServiceLevelDiscountingEnabled();
    return /*#__PURE__*/ React.createElement(Row, {
        middle: "xs",
        style: {
            flexGrow: 1
        }
    }, /*#__PURE__*/ React.createElement(Col, {
        xs: 4
    }, renderName(options)), /*#__PURE__*/ React.createElement(ValueColumn, {
        xs: displayDiscounts ? 3 : 5
    }, /*#__PURE__*/ React.createElement("div", null, totalHours), /*#__PURE__*/ React.createElement("label", null, "Total # of ", effortUnit)), /*#__PURE__*/ React.createElement(ValueColumn, {
        xs: 2
    }, /*#__PURE__*/ React.createElement("div", null, formatCurrency(totalRateCents.fullCost / 100)), /*#__PURE__*/ React.createElement("label", null, "List Price")), displayDiscounts && /*#__PURE__*/ React.createElement(ValueColumn, {
        xs: 2
    }, /*#__PURE__*/ React.createElement("div", null, formatCurrency(totalRateCents.discountedCost / 100)), /*#__PURE__*/ React.createElement("label", null, "Discounted Price")), groupIndex > 0 && /*#__PURE__*/ React.createElement(Col, {
        xs: true,
        style: {
            textAlign: "right"
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        disabled: disabled,
        onClick: function() {
            return dispatch({
                type: PhaseAllocationsActionsEnum.RemoveGroup,
                groupIndex: groupIndex
            });
        }
    }, /*#__PURE__*/ React.createElement(FaRegTrashAlt, null))));
};
export default function ItemGroup(props) {
    var itemGroup = props.itemGroup, groupIndex = props.index, selectedRegion = props.selectedRegion, formatCurrency = props.formatCurrency, dispatch = props.dispatch, isDisabledCb = props.isDisabledCb, getClassName = props.getClassName, hideDropdownsRow = props.hideDropdownsRow;
    var costOptions = {
        rateOverrideKey: selectedRegion,
        getDiscount: props.getDiscount,
        getPrice: props.getAddonPrice
    };
    var totalRateCents = phasesModule.utils.calculateItemGroupCost(itemGroup, costOptions);
    var totalHours = phasesModule.utils.calculateItemGroupHours(itemGroup);
    var disabled = isDisabledCb({
        itemGroup: itemGroup
    });
    return /*#__PURE__*/ React.createElement(PhaseCard, {
        className: getClassName({
            type: "itemGroup",
            props: props
        })
    }, /*#__PURE__*/ React.createElement(CardHeader, {
        divider: true
    }, props.renderHeader({
        renderHeader: defaultRenderHeader,
        renderName: function() {
            return "Phase ".concat(groupIndex + 1);
        },
        dispatch: dispatch,
        itemGroup: itemGroup,
        groupIndex: groupIndex,
        totalHours: totalHours,
        totalRateCents: totalRateCents,
        formatCurrency: formatCurrency,
        disabled: disabled,
        effortUnit: props.effortUnit
    })), /*#__PURE__*/ React.createElement(Droppable, {
        droppableId: "droppable:".concat(groupIndex)
    }, function(provided, snapshot) {
        return /*#__PURE__*/ React.createElement(CardBody, {
            ref: provided.innerRef,
            style: {
                paddingTop: "1.5rem"
            }
        }, itemGroup.itemRows.map(function(itemRow, rowIndex) {
            return /*#__PURE__*/ React.createElement(Draggable, {
                key: itemRow.key,
                draggableId: itemRow.key,
                index: rowIndex,
                isDragDisabled: disabled
            }, function(provided, snapshot) {
                return /*#__PURE__*/ React.createElement(ItemRow, _extends({
                    itemRow: itemRow,
                    index: rowIndex,
                    itemGroup: itemGroup,
                    groupIndex: groupIndex,
                    selectedRegion: selectedRegion,
                    dispatch: function(action) {
                        return dispatch(_objectSpreadProps(_objectSpread({}, action), {
                            groupIndex: groupIndex,
                            rowIndex: rowIndex
                        }));
                    }
                }, provided.draggableProps, provided.dragHandleProps, {
                    innerRef: provided.innerRef,
                    dragHandleProps: provided.dragHandleProps,
                    getClassName: getClassName,
                    renderHeader: props.renderItemRowHeader,
                    getDiscount: props.getDiscount,
                    getAddonPrice: props.getAddonPrice,
                    formatCurrency: formatCurrency,
                    isDisabledCb: isDisabledCb,
                    displayItemRowControls: props.displayItemRowControls,
                    displayDiscountedPrice: props.displayDiscountedPrice,
                    effortUnit: props.effortUnit,
                    usesDecimalNumbers: props.usesDecimalNumbers,
                    customComponents: props.customComponents,
                    hideDropdownsRow: hideDropdownsRow
                }));
            });
        }), provided.placeholder);
    }));
};
ItemGroup.propTypes = {
    dispatch: propTypes.func.isRequired,
    index: propTypes.number.isRequired,
    selectedRegion: propTypes.string,
    itemGroup: propTypes.shape({
        itemRows: propTypes.array
    }).isRequired,
    renderItemRowHeader: propTypes.func,
    getDiscount: propTypes.func,
    getAddonPrice: propTypes.func,
    formatCurrency: propTypes.func,
    displayItemRowControls: propTypes.bool,
    displayDiscountedPrice: propTypes.bool,
    effortUnit: propTypes.string,
    customComponents: propTypes.array,
    hideDropdownsRow: propTypes.bool
};
ItemGroup.defaultProps = {
    renderHeader: defaultRenderHeader
};
